import React from "react";
import { Link } from "react-router-dom";

const ArticleCard = ({ title, to, onClick }) => {
  const sharedProps = {
    className: "help-article-row",
    onClick,
  };

  return to ? (
    <Link to={to} {...sharedProps}>
      <span className="help-article-row-title">{title}</span>
      <span className="help-article-row-icon" aria-hidden="true">
        <i className="bi bi-chevron-right" />
      </span>
    </Link>
  ) : (
    <button type="button" {...sharedProps}>
      <span className="help-article-row-title">{title}</span>
      <span className="help-article-row-icon" aria-hidden="true">
        <i className="bi bi-chevron-right" />
      </span>
    </button>
  );
};

export default ArticleCard;
